// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"5fdda71e","87":"89e26341","418":"240f45da","800":"cb8bf605"}[chunkId] + ".chunk.css";
};